export const buildPlantName = (prefix, number) =>
  [prefix, number].filter(Boolean).join("-");

export const getPersonLabel = (person) =>
  typeof person === "object"
    ? person?.name || person?.email || "-"
    : person || "-";
